import CustomerStoryHorizontal from "@components/BasicComponents/Cards/CustomerStory/CustomerStoryHorizontal"
import SwiperT from "@components/BasicComponents/Swiper/MySwiper"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"
import {SwiperSlide} from "swiper/react"

import styles from "./PinnedStories.module.scss"
type Props = {
	stories: CustomerStoryModuleType[]
	data: AdvancedSideAssetModuleType
}

const PinnedStories = (props: Props) => {
	const desiredSlugs = [
		"communicating-in-the-midst-of-geopolitical-turbulences",
		"streamlining-internal-communication-and-training-processes-at-global-manufacturer-rapala-vmc",
		"transforming-vocational-education-at-luksia-with-dream-broker-studio",
	]

	const matchedStories = desiredSlugs
		.map((slug) => props.stories.find((story) => story.slug === slug))
		.filter(Boolean) as CustomerStoryModuleType[]

	const matchedSlugs = new Set(matchedStories.map((story) => story.slug))
	const additionalStories = props.stories.filter(
		(story) => !matchedSlugs.has(story.slug),
	)

	const finalStories = [...matchedStories, ...additionalStories].slice(0, 3)

	return (
		<section>
			<ContainerWrapper style={{overflow: "hidden"}}>
				<Separator size={128}>
					<div className={styles.title}>
						<Typography
							content={props.data.sectionTitle}
							variant={Variant.SectionTitle}
						/>
					</div>
					<Separator size={64} />
					<SwiperT
						className={"SwiperCustomer"}
						module={finalStories.map((element, index) => (
							<React.Fragment key={index}>
								<SwiperSlide key={index}>
									<CustomerStoryHorizontal
										className={styles.cardContainer}
										data={element}
									/>
								</SwiperSlide>
							</React.Fragment>
						))}
						spaceBetween={200}
					/>
					<Separator id={"startOfPagination"} size={32} />
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default PinnedStories
